export enum Icons {
    Calendar = 'calendar',
    Print = 'print',
    User = 'user',
    Connector = 'connector',
    Close = 'close',
    Checkmark = 'checkmark',
    Lock = 'lock',
    LockOutline = 'lock-outline',
    ArrowUp = 'arrow',
    Arrow = 'arrow_active',
    Mail = 'mail',
    Assignment = 'assignment',
    Piggy = 'piggy',
    Phone = 'phone',
    Home = 'home',
    Insurance = 'insurance',
    CloseLine = 'close-line',
    Cross = 'cross',
}
